module.exports = __webpack_public_path__ + "static/carrefourdevsummit22-616c7c5262b9ef9102bb6db138ff12ff.png";